import React from 'react';
import { NewReaction } from '@/types/models';
import { ReactionDiagramPreview } from '@/components/FunctionalArea/Modal/EditReactionModal/ReactionDiagramPreview.component';

type ReactionPreviewPanelProps = {
  reaction?: NewReaction;
};

export const ReactionPreviewPanel: React.FC<ReactionPreviewPanelProps> = ({ reaction }) => (
  <div className="relative flex h-[220px] w-full shrink-0 items-center justify-center overflow-hidden rounded border">
    {reaction && <ReactionDiagramPreview reaction={reaction} />}
  </div>
);
